import { render, staticRenderFns } from "./ExamSummary.vue?vue&type=template&id=fa5396fc&"
import script from "./ExamSummary.vue?vue&type=script&lang=js&"
export * from "./ExamSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports